window.storeTheme = window.storeTheme || ({} as StoreTheme);

const handleBuyQnt = () => {
  const $document = $(document);
  const init = () => {
    increseHandler();
    decreaseHandler();
    addToCart();
    onChangeInputQnt();
  };

  const updateQuantity = ($ele: any, quantity: number | string) => {
    $ele.attr('value', String(quantity));
    return $ele.attr('value') === String(quantity);
  };

  const increseHandler = () => {
    $document.on('click.product-increse-qnt', '.rnk-card-quantidade .c-btn-add', function () {
      const input = $(this).closest('div').find('input');
      const currentValue = Number(input.attr('value'));
      updateQuantity(input, String(currentValue + 1));
    });
  };

  const decreaseHandler = () => {
    $document.on('click.product-decrease-qnt', '.rnk-card-quantidade .c-btn-remove', function () {
      const input = $(this).closest('div').find('input');
      const currentValue = Number(input.attr('value'));
      updateQuantity(input, String(currentValue <= 1 ? 1 : currentValue - 1));
    });
  };

  const onChangeInputQnt = () => {
    $document.on('change', '.rnk-card-quantidade .c-quantidade', function () {
      const value = $(this).attr('value');
      updateQuantity($(this), value);
    });

    $document.on('change', '.rnk-card-quantidade .buy-in-page-quantity', function () {
      const value = $(this).attr('value');
      updateQuantity($(this), value);
    });
  };

  const addToCart = () => {
    const handleCart = async (e, retry = false) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      console.log($btn);

      const btnHtml = $btn.html();
      try {
        const $buttonBuyVtex = $btn
          .closest('li[layout], .rnk-handle-buy-container, .result-item')
          .find('.BottomBuy a, a.buy-in-page-button');
        let href = $buttonBuyVtex.attr('href');

        if (!href) {
          href = $btn.attr('href');
        }

        const quantity =
          +$btn
            .closest('[data-track-shelf="item"], .product-container, .result-item')
            .find('.rnk-card-quantidade .c-quantidade')
            .val() || 1;

        let sc = '';
        const { sku, seller, sc: prodSc } = window.storeTheme.helpers.url.getJsonFromUrl(href);
        sc = prodSc;

        if (!retry) {
          if (!window.storeTheme?.salesChannelSelector?.userWasPostalCode()) {
            window.dataLayer.push({
              event: 'gaEvent',
              gaEventCategory: 'Modal de localização',
              gaEventAction: 'Exibir modal',
              gaEventLabel: 'Cliente tentou add produto carrinho sem CEP definido',
              gaEventValue: 1,
            } as never);

            window.storeTheme?.salesChannelSelector?.showModal(handleCart.bind(this, $.Event(null, e), true));
            return;
          }
        }
        sc = window.storeTheme.salesChannelSelector.getSalesChannel();

        $btn.html(window.storeTheme.helpers.loader.getHtmlLoader());
        $btn.prop('disabled', true);

        const oderForm = window.vtexjs?.checkout?.orderForm;
        if (!oderForm) {
          await window.vtexjs.checkout.getOrderForm();
        }
        const index = (oderForm?.items || []).findIndex((prod) => String(prod.id) === String(sku));

        let result;
        if (index >= 0) {
          const updateItem = {
            quantity: oderForm.items[index].quantity + (isNaN(quantity) ? 1 : quantity) || 1,
            index,
          };
          result = await vtexjs.checkout.updateItems([updateItem], null, false);
          $(window).trigger('buy-qnt-update', [result, $btn]);
        } else {
          const item = {
            id: sku,
            quantity,
            seller,
          };

          result = await vtexjs.checkout.addToCart([item], null, sc);
          $(window).trigger('buy-qnt-add', [result, $btn]);
        }

        if (result?.messages?.length) {
          console.warn('❗️ From orderForm debug: ', result?.messages);
          $btn.html(btnHtml);
          $btn.prop('disabled', false);
        } else {
          $btn.html('<span class="icon-ok"></span>');
          // $(window).trigger('openWidgetCart');
          setTimeout(() => {
            $btn.html(btnHtml);
            $btn.prop('disabled', false);
          }, 3000);
        }
      } catch (error) {
        console.error('Fallback erros on handleCart', error);
        $btn.html(btnHtml);
        $btn.prop('disabled', false);
      }
    };
    $document.on('click', '.rnk-buy-btn, .buy-in-page-button, .wrapper-buy-button-asynchronous a', handleCart);
  };

  init();
};

Object.assign(window.storeTheme, { widgets: Object.assign(window.storeTheme.widgets || {}, { handleBuyQnt }) });

handleBuyQnt();

export default {};
